module Meevo.Components.Controls {
        
    export class BarcodeScannerModalController {
        static $inject = [
            "$timeout",
            "options",
            "callbacks",
        ];
        public scannerElement : string = 'desktop';
        
        private localStorageKey: string = 'meevo2.barcode-scanner';

        constructor(
            public $timeout: angular.ITimeoutService,
            public options: Meevo.Plugins.Product.IBarcodeScannerOptions,
            public callbacks: Meevo.Plugins.Product.IBarCodeScannerCallbacks
            ) {
                
            console.log('BARCODE SCANNER MODAL', this);
        }

        $onInit() { 
            setTimeout(() => {
                var el = $('md-dialog')[0];
                el.id = 'barcode-scanner-modal';
                this.makeDialogDraggable('barcode-scanner-modal');
                this.enableTouchSupport(el);
            }, 500)

            setTimeout(() => {
                this.setStartingPosition();
            }, 1);
            
        }

        setStartingPosition() : void {
            var localStorageData = this.getLocalStorageData();
            if (localStorageData && localStorageData.lastPosition) {
                $('md-dialog').css('inset', localStorageData.lastPosition)
            }
        }

        getLocalStorageData() : any {
            try {
                var json = JSON.parse(localStorage.getItem(this.localStorageKey)) || {};
                return json;
            } catch (error) {
                return null;
            }
        }

        updateLastPosition(insetValue) {
            try {
                var json = JSON.parse(localStorage.getItem(this.localStorageKey)) || {};
                json.lastPosition = insetValue;
                this.saveLocalStorageItem(json);
            } catch (error) {
                
            }
        }

        saveLocalStorageItem(obj) {
            try {
                localStorage.setItem(this.localStorageKey, JSON.stringify(obj));    
            } catch (error) { }
        }

        closeModal(isModal) : void {
            if (this.callbacks.onDestroy) {
                this.callbacks.onDestroy(isModal);
            }
        }

        barcodeScanned(codes) : void {
            if (this.callbacks.onScan) {
                this.callbacks.onScan(codes);
            }            
        }

        inventoryTypeChange(inventoryType) : void {
            if (this.callbacks.onInventoryTypeChange) {
                this.callbacks.onInventoryTypeChange(inventoryType);
            }
        }

        onBarcodeScanModeChange(scanMode) : void {
            if (this.callbacks.onBarcodeScanModeChange) {
                this.callbacks.onBarcodeScanModeChange(scanMode);
            }
        }

        makeDialogDraggable(wrapper) {
            var vm = this;
            this.$timeout(function() {
              $(function() {
                $('#' + wrapper).draggable({
                  containment: document.querySelector('body'),
                  start: function() {
                    $(this).css({ cursor: 'pointer' });
                  },
                  drag: function() {
                    $(this).css({ cursor: 'grabbing', transition: 'none' });
                  },
                  stop: function( event ) {
                    $(this).css({ cursor: 'pointer' });
                    vm.updateLastPosition($(event.target).css("inset"));                    
                  }
                });
              });
            }, 500);
        }

        touchHandler(event) {
            var touch = event.changedTouches[0];
        
            var simulatedEvent = document.createEvent("MouseEvent");
                simulatedEvent.initMouseEvent({
                touchstart: "mousedown",
                touchmove: "mousemove",
                touchend: "mouseup"
            }[event.type], true, true, window, 1,
                touch.screenX, touch.screenY,
                touch.clientX, touch.clientY, false,
                false, false, false, 0, null);
        
            touch.target.dispatchEvent(simulatedEvent);
            event.preventDefault();
        }

        enableTouchSupport(el: HTMLElement) {
            el.addEventListener("touchstart", this.touchHandler, true);
            el.addEventListener("touchmove", this.touchHandler, true);
            el.addEventListener("touchend", this.touchHandler, true);
            el.addEventListener("touchcancel", this.touchHandler, true);
        }
        
    }

    angular.module("meevo.components.controls")
        .controller("meevo.components.controls.BarcodeScannerModalController", BarcodeScannerModalController);
}

